import { Routes } from '@angular/router';
import { HotlineCalendarComponent } from '@src/app/features/hotline/components/hotline-calendar/hotline-calendar.component';
import { PendingChangesGuard } from '@src/app/_guards/changes.guard';
import { HotlineListComponent } from '@src/app/features/hotline/components/hotline-list/hotline-list.component';
import { HotlineUsersComponent } from '@src/app/features/hotline/components/hotline-users/hotline-users.component';
import { HotlineDetailComponent } from '@src/app/features/hotline/components/hotline-detail/hotline-detail.component';
import { HotlineImportComponent } from '@src/app/features/hotline/components/hotline-import/hotline-import.component';
import { AuthGuard } from '@src/app/_guards/auth.guard';

export const HOTLINE_ROUTES: Routes = [
    {
        path: 'hotline',
        children: [
            {
                path: 'create',
                component: HotlineCalendarComponent,
                data: {
                    title: 'Vytvořit hotline',
                    breadcrumb: [
                        {
                            label: 'Hot-Line',
                            url: '/hotline',
                        },
                        {
                            label: 'Vytvořit hotline',
                            url: '',
                        },
                    ],
                },
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'list',
                component: HotlineListComponent,
                data: {
                    title: 'Fronta hotline',
                    breadcrumb: [
                        {
                            label: 'Hot-Line',
                            url: '/hotline',
                        },
                        {
                            label: 'Fronta hotline',
                            url: '',
                        },
                    ],
                },
            },
            {
                path: 'users',
                component: HotlineUsersComponent,
                data: {
                    title: 'Seznam hotlinerů',
                    breadcrumb: [
                        {
                            label: 'Hot-Line',
                            url: '/hotline',
                        },
                        {
                            label: 'Seznam hotlinerů',
                            url: '',
                        },
                    ],
                },
            },
            {
                path: 'detail/:id',
                component: HotlineDetailComponent,
                data: {
                    title: 'Detail hot-line',
                    breadcrumb: [
                        {
                            label: 'Hot-Line',
                            url: '/hotline',
                        },
                        {
                            label: 'Detail hot-line',
                            url: '',
                        },
                    ],
                },
            },
            {
                path: 'import',
                component: HotlineImportComponent,
                data: {
                    title: 'Import hot-line',
                    breadcrumb: [
                        {
                            label: 'Hot-Line',
                            url: '/hotline',
                        },
                        {
                            label: 'Import hot-line',
                            url: '',
                        },
                    ],
                },
            },
        ],
        canActivate: [AuthGuard],
    },
];
